import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { BehaviorSubject, combineLatest, Observable } from 'rxjs';
import { EnvironmentService } from './environment.service';
import { map, take } from 'rxjs/operators';
import { UserService } from './user.service';
import { MenuListService } from './menu-list.service';

@Injectable({
  providedIn: 'root',
})
export class HomeGuard {
  constructor(
    public environmentService: EnvironmentService,
    private router: Router,
    private userService: UserService,
    private menuListService: MenuListService
  ) {}
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    const result = new BehaviorSubject(true);

    combineLatest([
      this.environmentService.getInstanceDetails(),
      this.environmentService.getActiveFeature()
    ])
      .pipe(
        take(1),
        map(([details, activeFeature]: [any, any]) => {
          const roleInfo = this.userService['_roleInformation'];

          const availableMenuItems = this.menuListService.getGlobalMenu(
            details,
            roleInfo,
            activeFeature
          );

          const hasHomeInMenu = availableMenuItems.some(
            item => item.link === '/home'
          );

          if (hasHomeInMenu) {
            result.next(true);
          } else if (availableMenuItems.length > 0) {
            this.router.navigate([availableMenuItems[0].link]);
            result.next(false);
          } else {
            this.router.navigate(['/error']);
            result.next(false);
          }
        })
      )
      .subscribe();
    return result;
  }
}
